import { render, staticRenderFns } from "./Stage4.vue?vue&type=template&id=5d50bc3d&scoped=true&"
import script from "./Stage4.vue?vue&type=script&lang=js&"
export * from "./Stage4.vue?vue&type=script&lang=js&"
import style0 from "./Stage4.vue?vue&type=style&index=0&id=5d50bc3d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d50bc3d",
  null
  
)

export default component.exports